import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class UserProfileKeys extends MainKeys {
    get place() {
        return Places.profile
    }
}

export default UserProfileKeys
